import React from 'react';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../root/tcsm-model';
import { useQuery } from '../../hooks/useQuery';
import { SuccessMessageWithNBA } from '../../models/epi-model';
import { MappedMessage } from './mapped-message-display';
import { FormTypes } from '../../../pages/account-info/models/form-models';

interface SuccessMessageProps {
	successfulAction: string;
	supplement?: string | JSX.Element;
}
export function QuerySuccessMessage(props: SuccessMessageProps) {
	const { successfulAction, supplement } = props;

	const epiConfig = useSelector<TcsmStates, { [key: string]: SuccessMessageWithNBA }>(state => state?.epiProps?.siteSettingsState?.siteSettings.apiResponseMessages);

	const renderSuccess = useQuery()?.get('success') === successfulAction;

	if (!renderSuccess) return null;

	const mappedMessage = epiConfig[successfulAction];

	const isWarning = successfulAction === FormTypes.NEW_HIRE_SPOUSE_UPDATE_SUCCESS_WITH_WARNING;

	return (
		<>
			<MappedMessage message={mappedMessage?.title} supplement={supplement || mappedMessage?.message} useWarning = {isWarning}/>
		</>

	);
}

QuerySuccessMessage.defaultProps = {
	supplement: null,
};